import './index.scss'

!(function(){
  $('.header').addClass('black')
})()